import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=0c132f32&"
import script from "./submenu.vue?vue&type=script&lang=js&"
export * from "./submenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c132f32')) {
      api.createRecord('0c132f32', component.options)
    } else {
      api.reload('0c132f32', component.options)
    }
    module.hot.accept("./submenu.vue?vue&type=template&id=0c132f32&", function () {
      api.rerender('0c132f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/menu/src/submenu.vue"
export default component.exports